// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-simple/accolades-list-simple.component.scss
// module id = 75
// module chunks = 0